// extracted by mini-css-extract-plugin
module.exports = {"root":"GraphCard_root__OtlWX","a11yContent":"GraphCard_a11yContent__fDbHA","rotation":"GraphCard_rotation__SPlpn"};